import './authorization-list-controller';
import './authorization-details-controller';
import './authorization-data-controller';
import './authorization-form-controller';
import './authorization-items-detalhe-modal-controller';